import { useYardStores } from '@yard/AppProvider'
import { useTranslate } from '@tolgee/react'
import { ConfirmationDialog } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { DGSegregationRuleFormProfile } from '../forms/dg-segregation-rules-table-form/dg-segregation-rules-table-form.profile'
import DGSegregationRulesTableForm from '../forms/dg-segregation-rules-table-form/DGSegregationRulesTableForm'

const DGSegregationRulesTableDialog = observer(() => {
  const { t } = useTranslate()
  const { dgSegregationRulesTableUIStore } = useYardStores()

  const formId = 'dg-segregation-rules-table-form'

  const handleOnClose = () => dgSegregationRulesTableUIStore.closeDialog()

  const handleOnClear = async () => await dgSegregationRulesTableUIStore.clear()

  const handleOnSubmit = async (formValues: DGSegregationRuleFormProfile) => {
    const { distance, isProhibited } = formValues
    await dgSegregationRulesTableUIStore.save(distance, isProhibited)
  }

  const selectedCell = dgSegregationRulesTableUIStore.getSingleSelectedCell()
  const selectedCellLabel = selectedCell
    ? `Class ${selectedCell.row} ↔ Class ${selectedCell.col}`
    : undefined

  return (
    <>
      <ConfirmationDialog
        open={dgSegregationRulesTableUIStore.isDialogOpen}
        title={t('editDGSegregationRules', 'Edit DG Segregation Rules')}
        primaryActionText={t('save', 'Save')}
        secondaryActionText={t('clearSelection', 'Clear Selection')}
        onSecondaryAction={handleOnClear}
        closeLabel={t('cancel', 'Cancel')}
        formId={formId}
        maxWidth='xs'
        onClose={handleOnClose}
        blockClickOutside
      >
        <DGSegregationRulesTableForm
          id={formId}
          initialValues={dgSegregationRulesTableUIStore.getSelectedRuleFormValues()}
          selectedCellLabel={selectedCellLabel}
          onSubmit={handleOnSubmit}
        />
      </ConfirmationDialog>
      <ConfirmationDialog
        open={dgSegregationRulesTableUIStore.isResetDialogOpen}
        title={t('resetDGSegregationRulesToDefaults', 'Reset DG Segregation Rules to Defaults')}
        primaryActionText={t('resetToDefaults', 'Reset to defaults')}
        closeLabel={t('cancel', 'Cancel')}
        maxWidth='xs'
        message={t(
          'resetDGSegregationRulesToDefaultsConfirmation',
          'This will overwrite all current DG segregation rules for this tenant with the default IMDG segregation matrix.',
        )}
        onClose={() => dgSegregationRulesTableUIStore.toggleResetDialog()}
        onConfirm={() => dgSegregationRulesTableUIStore.resetToDefaults()}
        blockClickOutside
      />
    </>
  )
})

export default DGSegregationRulesTableDialog
